/* eslint-disable no-unused-vars */
export enum INTERACTION_PARAMS {
  sync_with_portfolios_app = 'sync_with_portfolios_app',
}

export type InteractionParams = {
  [INTERACTION_PARAMS.sync_with_portfolios_app]: boolean;
};

export type JobParams = {
  point_in_time_tickers?: boolean;
  app_portfolio_id?: number;
};

export type Params = InteractionParams & JobParams;
export type DraftParams = Partial<Params>;
